import React, { FC, useContext, useState } from 'react';
import { RoleSectionWrapper } from './roleSections.styles';
import { RadioButtonField, IconButton } from '@sainsburys-tech/luna-react';
import { Plus } from '@sainsburys-tech/luna-icons';
import { Drawer } from '@mui/material';
import { ApolloError, gql } from '@apollo/client';
import { IOptionWithDefault } from '@interfaces/option.interface';
import { AuthContext } from 'src/providers/AuthProvider';
import { RoleUpdateHiddenForRequestsScreen } from '../screens/roleUpdateHiddenForRequestsScreen';
import { NotificationType } from '@enums/notificationTypes.enum';
import {
  RoleDetailsSectionHide_RoleDetailsFragment,
} from 'src/operations/generated/graphql';
import { RoleUpdateHiddenForRegistrationScreen } from '../screens/roleUpdateHiddenForRegistrationScreen';
import { IDetailsToChange } from '../manageRole';

interface ISectionDetails {
  handleConfirmation: (value: IDetailsToChange) => Promise<void>;
  loading: boolean;
  error: ApolloError | undefined;
  target: { id: string; displayName: string };
  role: RoleDetailsSectionHide_RoleDetailsFragment;
}
enum PanelAction {
  HIDDEN_FROM_REGISTRATION = 'HIDDEN_FROM_REGISTRATION',
}

gql`
  fragment RoleDetailsSectionHide_RoleDetails on RoleProjection {
    id
    hideFromRegistration
    name
    accountType {
      value {
        id
      }
    }
  }
`;

export const RoleHiddenRegistrationSection: FC<ISectionDetails> = ({
  role,
  handleConfirmation,
  loading,
  error,
  target,
}) => {
  //@ts-ignore
  const { isAccountTypeAdminOf } = useContext(AuthContext);
  const [showSidePanel, setShowSidePanel] = useState<PanelAction | null>(null);
  const [feedBackMessage, setFeedBackMessage] =
    useState<NotificationType | null>(null);
  const handlePanelClose = () => {
    setShowSidePanel(null);
    setFeedBackMessage(null);
  };
  const PlusIcon = Plus as unknown as React.FC;
  const defaultOption = (value: boolean): IOptionWithDefault[] => {
    const options = [
      { value: 'yes', label: 'Yes' },
      { value: 'no', label: 'No' },
    ];
    const opt = value ? 'yes' : 'no';
    return options.map(option => {
      return {
        ...option,
        defaultChecked: option.value === opt,
      };
    });
  };

  const renderPanel = () => {
    switch (showSidePanel) {
      case PanelAction.HIDDEN_FROM_REGISTRATION:
        return (
          <RoleUpdateHiddenForRegistrationScreen
            target={{
              id: role.id,
              displayName: role?.name || '',
            }}
            loading={loading}
            error={error}
            handleClose={handlePanelClose}
            handleConfirmation={handleConfirmation}
            radioHeading={{
              heading: 'Hide from registration?',
              subHeading:
                'Do you want to prevent users from seeing this role during registration?',
              feedBackStatus: 'hide-role',
            }}
            defaultValue={role?.hideFromRegistration || false}
          />
        );
      case PanelAction.HIDDEN_FROM_REGISTRATION:
        return <div>Hidden from registration panel</div>;
    }
  };

  return (
    <RoleSectionWrapper>
      {role && (
        <>
          <RadioButtonField
            label={<h4>Hide from registration?</h4>}
            info={
              'Do you want to prevent users from seeing this role during registration?'
            }
            name='radio-button-field-hide-from-registrations'
            fullWidth
            options={defaultOption(role?.hideFromRegistration || false)}
            value={role?.hideFromRegistration ? 'yes' : 'no'}
          />
          <div className='action-panel'>
            <IconButton
              variant='text'
              circle={false}
              disabled={!isAccountTypeAdminOf(role.accountType.value.id)}
              hard={false}
              element='button'
              label='Edit access'
              color='dark'
              onClick={() => {
                setShowSidePanel(PanelAction.HIDDEN_FROM_REGISTRATION);
              }}
            >
              <PlusIcon />
            </IconButton>
          </div>
          <Drawer
            open={showSidePanel !== null}
            onClose={handlePanelClose}
            anchor='right'
            className='view-application'
          >
            {renderPanel()}
          </Drawer>
        </>
      )}
    </RoleSectionWrapper>
  );
};
